import { useEffect } from 'react';
import { useAPIContext, useStoreContext } from '../../../../components/Context';
import { getZonePoint } from '../../zone/selectors';
import { createAsyncState } from '../hooks';
import { useAuthorizationState } from '../authorization/hooks';
var usePaymentsAsync = createAsyncState('payments');
export var usePaymentsQuery = function () {
    var _a;
    var state = useStoreContext()[0];
    var payments = useAPIContext().payments;
    var _b = usePaymentsAsync(), asyncState = _b[0], actions = _b[1];
    var isAuthorized = ((_a = useAuthorizationState().data) === null || _a === void 0 ? void 0 : _a.authorization_status) === 'authorized';
    var zonePoint = isAuthorized ? getZonePoint(state) : undefined;
    useEffect(function () {
        if (payments && zonePoint) {
            actions.start();
            return payments({
                body: {
                    point: zonePoint,
                },
                onSuccess: actions.success,
                onError: actions.error,
            });
        }
    }, [actions, payments, zonePoint]);
    return asyncState;
};
export var usePaymentsState = function () { return usePaymentsAsync()[0]; };
